export const getRootScope = state => state.rootScope;
export const getLastLocation = state => state.rootScope.lastLocation;
export const getCurrentUser = state => state.rootScope.currentUser;